import type { Router } from 'vue-router'
import type { ApiConfig, ClientType } from '../interfaces/IApiConfig'

class ApiConfigManager {
    private config: ApiConfig = {
        clientType: null,
    }

    setConfig(newConfig: Partial<ApiConfig>) {
        this.config = { ...this.config, ...newConfig }
    }

    getConfig(): ApiConfig {
        return this.config
    }

    getClientType(): ClientType {
        return this.config.clientType
    }

    getRouter(): Router | undefined {
        return this.config.router
    }

    getHomeUrl(): string | undefined {
        return this.config.homeUrl
    }

    getLoginName(): string | undefined {
        return this.config.loginName
    }
}

export const apiConfig = new ApiConfigManager()
